import KeyCodes from 'lib/utils/KeyCodes';
import React, { useEffect, useRef, useState } from 'react';
import './style.scss';

interface IProps {
    editable?: boolean;
    defaultValue?: any;
    value?: any;
    alwaysEdit?: boolean;
    onEnter?: (e) => void;
    onSave?: (value, callback) => void;
    onBlur?: (value, callback) => void;
    saveOnBlur?: boolean;
    size?: string;
    dark?: boolean;
    label?: string;
    type?: string;
    placeholder?: string;
    autoComplete?: string;
    error?: string;
    control?: any;
}

const FormRowEditField = (props: IProps) => {
    const [initialValue, setInitialValue] = useState(props.value || '');
    const [value, setValue] = useState('');
    const [editing, setEditing] = useState(props.alwaysEdit || false);
    const editable = props.editable !== undefined ? props.editable : true;
    const inputRef = useRef();

    useEffect(() => {
        if (props.value) {
            setValue(props.value)
        }
    }, [])

    // sets initial value
    useEffect(() => {
        if (props.defaultValue) {
            setValue(props.defaultValue)
        }
    }, [props.defaultValue]);

    const onSaveCallback = (saved, val) => {
        if (saved) {
            setInitialValue(val);
            setValue(val);
        } else {
            // restore previous value
            setValue(initialValue);
        }
    }

    // save=true means it was a button click, and this should handle the saving itself.
    const toggleEdit = (save = true) => {
        try {
            if (!props.alwaysEdit) {
                setEditing(!editing);
            }

            if (editing && inputRef && save) {
                let val = inputRef.current.value;
                props.onSave(val, (r) => onSaveCallback(r, val));
            }
        } catch (e) {
            console.log(`Error`, e);
        }
    }

    onKey = (e) => {
        if (e.keyCode == KeyCodes.ESCAPE) { //escape
            toggleEdit(false);
        }

        if (e.keyCode == KeyCodes.ENTER) { // enter
            try {
                let val = e.target.value;

                if (props.saveOnEnter) {
                    if (props.onSave) {
                        props.onSave(val, (r) => {
                            if (r) onSaveCallback(r, val);

                            // this is hard to support because it implies the save should finish first, which isn't the case (need to use callback).
                            // if (props.onEnter) {
                            //     props.onEnter(e);
                            // }
                        });
                    }
                }

                if (!props.alwaysEdit) {
                    toggleEdit(false);
                } else {
                    if (inputRef && inputRef.current) {
                        inputRef.current.blur();
                    }
                }
            } catch (e) {
                console.log(`Error`, e);
            }
        }

        if (props.onChange) {
            props.onChange(e.target.value, (r) => {
                if (r) {
                    //setInitialValue(val);
                    setValue(r);
                }
            });
        }
    }

    onBlur = (e) => {
        try {
            let val = e.target.value;

            if (props.saveOnBlur && props.onSave) {
                props.onSave(e.target.value, (r) => {
                    onSaveCallback(r, val);
                });
            }

            if (props.onBlur) {
                props.onBlur(e.target.value, (r) => {
                    //onBlurCallback(r, val);
                });
            }

            // if (!props.alwaysEdit) {
            //     toggleEdit(false);
            // }
        } catch (e) {
            console.log(`Error`, e);
        }
    }

    return (
        <div className="form-row-edit-field">
            <div className="form-row-field-input">
                <h3 className="label">{props.label}</h3>
                {!editing && <div className="value">{value || props.placeholder || ''}</div>}

                {editing && <div className="value-edit">
                    {props.control ? props.control :
                        <input type={props.type || 'text'} className={"input simple " +
                            (props.dark ? ' dark' : '') +
                            (props.size ? ` size-${props.size}` : '')}
                            placeholder={props.placeholder || ''}
                            autoComplete={props.autoComplete || ''}
                            defaultValue={value}
                            //onChange={(e) => { updateValue(e.target.value) }}
                            onKeyUp={onKey}
                            onBlur={onBlur}
                            ref={inputRef}
                        />
                    }
                </div>}

            </div>
            {!props.alwaysEdit && editable &&
                <button className="form-row-edit-btn" onClick={toggleEdit}>
                    {editing ? 'Save' : 'Edit'}
                </button>
            }
        </div>
    );
}

export default FormRowEditField;